import { useState } from 'react'
import format from '../utils/format'

const useAppState = () => {
  let todayDate = new Date()
  let nextYearDate = new Date()
  nextYearDate.setFullYear(nextYearDate.getFullYear() + 1)
  nextYearDate.setDate(nextYearDate.getDate() - 1)
  // DY_20230623 - add addCity
  const [insured, setInsured] = useState({
    name: '',
    id: '',
    id2: '',
    malaysianPassport: true,
    dateOfBirth: '',
    gender: '',
    height: '',
    weight: '',
    email: '', // overseas
    email2: '', // domestic
    email3: '', // annual
    verifyEmail: '',
    mobile: '',
    nationality: 'MY',
    address1: '',
    address2: '',
    address3: '',
    postcode: '',
    addState: '',
    addCity: '',
    declare1: '',
    declare2: '',
    declare3: '',
    pdpaAgree: '',
    tncAgree: '',
    declareBox: '',
    selectedPlan: '',
    selectedCoverage: '',
    tripType: 'Single',
    travelType: 'overseas',
    travelPackage: '',
    headCount: 1,
    adultCount: 1,
    childCount: 0,
    selectedCountries: '',
    pocFrom: `${todayDate.getMonth() + 1}/${todayDate.getDate()}/${todayDate.getFullYear()}`,
    pocTo: ``,
    isDeductible: false,
    isActive: true,
    cp1: true,
    cp2: false,
    cp3: false,
    curArea: '',
    isMaxHeadCount: false,
    isMinHeadCount: true,
    isMaxHeadCountChild: false,
    isMinHeadCountChild: true,
    nomineeDOB: ``,
    isDOBLock: false,
    quoteOption: 'overseas',
  })

  const [plans, setPlans] = useState([
    {
      name: 'Prime A1',
      code: 'PA1-1-5',
      plandescription: '',
      grossPremium: 569,
      rebate: 15,
      grossPremiumAfterRebate: 500,
      serviceTax: 6,
      stampDuty: 10,
      total: 510,
      annualLimit: 0,
    },
    {
      name: 'Prime B1',
      code: 'PB1-1-5',
      plandescription: '',
      grossPremium: 610,
      rebate: 15,
      grossPremiumAfterRebate: 500,
      serviceTax: 6,
      stampDuty: 10,
      total: 510,
      annualLimit: 0,
    },
    {
      name: 'Prime C1',
      code: 'PC1-1-5',
      plandescription: '',
      grossPremium: 629,
      rebate: 15,
      grossPremiumAfterRebate: 500,
      serviceTax: 6,
      stampDuty: 10,
      total: 510,
      annualLimit: 0,
    },
  ])
  const [nominees, setNominees] = useState([])
  const [details, setDetails] = useState({
    transId: '',
    returnstatus: '',
    amt: '',
    refNo: '',
    effectDate: '',
    expDate: '',
    ins_name: '',
    planType: '',
    transDate: '',
    paymentType: '',
    emailAddress: '',
  })

  const reduceInsured = (state) => {
    let nric = ''
    if ((!insured.id || insured.id.length < 12) && state.dateOfBirth) {
      const dob = format.date(state.dateOfBirth)
      nric = `${dob.substr(-2)}${dob.substr(3, 2)}${dob.substr(0, 2)}` + '-'
    }
    setInsured({
      ...insured,
      ...state,
      id: nric ? nric : state.id || insured.id,
    })
  }

  const [language, setLanguage] = useState('en')
  const [inputAreaList, setInputAreaList] = useState([])
  const [inputList, setInputList] = useState([])
  const [isStampDutyWaived, setIsStampDutyWaived] = useState(false)
  const [tin, setTin] = useState('')
  const [showMaintenance, setShowMaintenance] = useState({ title: '', message: '' })

  const defaultQuoteState = {
    travelType: "",
    travelFromDate: "",
    travelToDate: "",
    travelPackage: "",
    travelTrip: "",
    adultPax: 0,
    childPax: 0,
    destination: null,
    destinationList: [],
    productType: "",
    dob: "",
    email: {},
    email2: {},
    email3: {}
  };

  const [quotePayload, setQuotePayload] = useState(defaultQuoteState);

  return {
    insured,
    setInsured: reduceInsured,
    plans,
    setPlans,
    details,
    setDetails,
    inputAreaList,
    setInputAreaList,
    inputList,
    setInputList,
    nominees,
    setNominees,
    language,
    setLanguage,
    isStampDutyWaived,
    setIsStampDutyWaived,
    tin,
    setTin,
    showMaintenance,
    setShowMaintenance,
    quotePayload,
    setQuotePayload
  }
}

export default useAppState
